export const chapters = [
    {
      "chapter": "0",
      "name": "not-found",
      "description": "no chaper no avilable",
      "keywords": [],
      "types": ["edible"]
    },
    {
      "chapter": "1",
      "name": "live-animal",
      "description": "Live Animals – Covers all live animals such as cattle, sheep, horses, and poultry.",
      "keywords": ["animal", "cattle", "sheep", "horses", "poultry"],
      "industry": ["animal"],
      "types": []
    },
    {
      "chapter": "2",
      "name": "meat",
      "description": "Meat & Edible Meat Offal – Includes fresh, chilled, frozen, or preserved meats of various animals.",
      "keywords": ["meat"],
      "industry": ["food", "meat", "non-veg"],
      "types": ["edible"]
    },
    {
      "chapter": "3",
      "description": "Fish & Crustaceans, Mollusks, and Other Aquatic Invertebrates – Covers seafood, fish fillets, and fishmeal.",
      "keywords": ["seafood", "fish", "fillets", "fishmeal"],
      "industry": ["food", "fish"],
      "types": ["edible"],
      "name": "fish"
    },
    {
      "chapter": "4",
      "description": "Dairy Products, Eggs, Natural Honey, Edible Animal Products – Includes milk, cream, butter, cheese, and honey.",
      "keywords": [
        "milk",
        "dairy",
        "eggs",
        "honey",
        "cream",
        "butter",
        "cheese",
        "honey"
      ],
      "industry": ["food", "dairy"],
      "types": ["edible"],
      "name": "dairy"
    },
    {
      "chapter": "5",
      "description": "Animal-Origin Products (Not Elsewhere Specified) – Covers non-edible products like bones, shells, and animal hair.",
      "keywords": ["bone", "shell", "animal hair", "woolen"],
      "industry": ["animal", "non-food"],
      "types": [],
      "name": "animal-origin-non-edible"
    },
    {
      "chapter": "6",
      "description": "Live Trees & Plants – Covers nursery plants, flowers, and seeds.",
      "keywords": ["plant", "nursery", "flowers", "seeds"],
      "industry": ["nutra", "plant", "agriculture", "seeds"],
      "types": ["edible"],
      "name": "live-trees"
    },
    {
      "chapter": "7",
      "description": "Edible Vegetables & Certain Roots and Tubers – Includes fresh and dried vegetables, potatoes, and onions.",
      "keywords": [],
      "types": ["edible"],
      "name": "vegetable"
    },
    {
      "chapter": "8",
      "description": "Edible Fruits & Nuts; Citrus Peel & Melons – Includes apples, bananas, coconuts, almonds, and citrus peel.",
      "keywords": [
        "fruits",
        "apple",
        "banana",
        "coconut",
        "almond",
        "citrus peel"
      ],
      "types": ["edible"],
      "name": "fruit-nut"
    },
    {
      "chapter": "9",
      "description": "Coffee, Tea, Mate & Spices – Covers tea, coffee, vanilla, pepper, and other spices.",
      "keywords": [],
      "types": ["edible"],
      "name": "coffee-tea"
    },
    {
      "chapter": "10",
      "description": "Cereals – Includes wheat, rice, maize, barley, and oats.",
      "keywords": [],
      "types": ["edible"],
      "brands": [
        {
          "name": "marigold",
          "desc": "Rice brand",
          "productName": "PARBOILED RICE SILKY SORTEX (NON BASAMATHI)"
        }
      ],
      "name": "cereals"
    },
    {
      "chapter": "11",
      "description": "Milling Products, Malt, Starches, Inulin, Wheat Gluten – Covers flour, starch, and other grain derivatives.",
      "keywords": [
        "malt",
        "Starches",
        "Gluten",
        "Wheat",
        "Inulin",
        "flour",
        "grain",
        "powder"
      ],
      "types": ["edible"],
      "name": "milling-malt"
    },
    {
      "chapter": "12",
      "description": "Oilseeds, Oleaginous Fruits, Industrial & Medicinal Plants – Includes soybeans, sunflower seeds, and medicinal herbs.",
      "keywords": ["oilseeds"],
      "types": ["edible"],
      "name": "oilseed"
    },
    {
      "chapter": "13",
      "description": "Lac, Gums, Resins & Other Vegetable Saps – Covers natural resins and plant-based gums.",
      "keywords": [],
      "types": ["edible"],
      "name": "vegetable-saps-gum"
    },
    {
      "chapter": "14",
      "description": "Vegetable Plaiting Materials & Other Plant-Based Products – Includes bamboo, rattan, and straw.",
      "keywords": ["vegetable plaiting"],
      "types": [],
      "name": "vegetable-plaiting"
    },
    {
      "chapter": "15",
      "description": "Animal/Veg Oils & Fats; Processed Fats – Includes vegetable oils (palm, sunflower, olive) and hydrogenated fats.",
      "keywords": ["animal oil","animal fat"],
      "name": "animal-oil-fat"
    },
    {
      "chapter": "16",
      "description": "Meat, Fish, & Seafood Preparations – Includes canned fish, sausages, and fish extracts.",
      "keywords": [],
      "types": ["edible"],
      "name": "meat"
    },
    {
      "chapter": "17",
      "description": "Sugars & Sugar Confectionery – Covers raw sugar, refined sugar, and confectionery items.",
      "keywords": [],
      "types": ["edible"],
      "name": "sugars"
    },
    {
      "chapter": "18",
      "description": "Cocoa & Cocoa Preparations – Includes chocolate, cocoa powder, and cocoa butter.",
      "keywords": [],
      "types": ["edible"],
      "name": "cocoa-chocolate"
    },
    {
      "chapter": "19",
      "description": "Cereal, Flour, Starch, or Milk Preparations – Covers pasta, bread, and bakery products.",
      "keywords": [],
      "types": ["edible"],
      "name": "cereal-flour"
    },
    {
      "chapter": "20",
      "description": "Vegetable, Fruit, Nut, & Other Edible Plant Preparations – Includes jams, fruit juices, and pickles.",
      "keywords": ["jam", "juice", "vegetable", "fruit", "pickle"],
      "types": ["edible"],
      "name": "vegetable-juice-fruit"
    },
    {
      "chapter": "21",
      "description": "Miscellaneous Edible Preparations – Covers soups, sauces, and protein concentrates.",
      "keywords": ["soups", "sauces", "protein concentrates"],
      "types": ["edible"],
      "name": "soups-sauces-protein"
    },
    {
      "chapter": "22",
      "description": "Beverages, Spirits, & Vinegar – Includes alcoholic drinks, juices, and vinegar.",
      "keywords": ["beverage", "spirit", "vinegar", "alcoholic", "juice"],
      "types": ["edible"],
      "name": "beverages-spirit"
    },
    {
      "chapter": "23",
      "description": "Residues & Waste from Food Industries; Animal Feed – Covers oilcake and residues from milling.",
      "keywords": ["feed", "animal feed", "oil cakes"],
      "types": [],
      "name": "residues-animal-feed-food-waste"
    },
    {
      "chapter": "24",
      "description": "Tobacco & Manufactured Tobacco Substitutes – Includes cigars, cigarettes, and tobacco extracts.",
      "keywords": [],
      "types": ["edible"],
      "name": "tobacco-cigars-cigarette"
    },
    {
      "chapter": "25",
      "description": "Salt, Sulfur, Earth, & Stone; Plastering Materials, Lime, Cement – Includes building materials like limestone, chalk, and salt.",
      "keywords": [],
      "types": [],
      "name": "salt-lime-earth"
    },
    {
      "chapter": "26",
      "description": "Ores, Slag, & Ash – Covers raw minerals like iron ore, copper ore, and coal slag.",
      "keywords": [],
      "types": [],
      "name": "ore-ash-ironore,"
    },
    {
      "chapter": "27",
      "description": "Mineral Fuels, Oils & Products of Their Distillation – Includes crude oil, petroleum, coal, and natural gas.",
      "keywords": [],
      "types": [],
      "name": "mineral-fuel-oil"
    },
    {
      "chapter": "28",
      "description": "Inorganic Chemicals, Compounds of Precious Metals – Includes sulfuric acid, ammonia, and rare earth elements.",
      "keywords": [],
      "types": [],
      "name": "inorganic-chemical"
    },
    {
      "chapter": "29",
      "description": "Organic Chemicals – Covers benzene, alcohols, and chemical compounds.",
      "keywords": [],
      "types": ["edible"],
      "name": "organic-chemical"
    },
    {
      "chapter": "30",
      "description": "Pharmaceutical Products – Includes medicines, vaccines, and antibiotics.",
      "keywords": [],
      "types": ["edible"],
      "name": "pharmaceutical-medicine"
    },
    {
      "chapter": "31",
      "description": "Fertilizers – Covers nitrogen-based, phosphorus-based, and organic fertilizers.",
      "keywords": [],
      "name": "fertilizers"
    },
    {
      "chapter": "32",
      "description": "Tanning, Dyeing Extracts, Paints, & Varnishes – Includes pigments, paints, and ink.",
      "keywords": [],
      "name": "dyes-paints,"
    },
    {
      "chapter": "33",
      "description": "Essential Oils & Resinoids; Perfumes & Cosmetics – Covers perfumes, oils, and skincare.",
      "keywords": ["oil", "cosmetics", "perfumes", "oils", "skincare"],
      "types": [],
      "name": "essential-oil-perfumes"
    },
    {
      "chapter": "34",
      "description": "Soap, Wax, & Cleaning Preparations – Includes soaps, detergents, and candles.",
      "keywords": ["soap", "detergents", "candles"],
      "types": [],
      "name": "soap-detergents"
    },
    {
      "chapter": "35",
      "description": "Albuminoidal Substances; Starches, Glues, Enzymes – Covers gelatin, enzymes, and glue.",
      "keywords": [],
      "types": ["edible"],
      "name": "glues-enzymes-albuminoidal"
    },
    {
      "chapter": "36",
      "description": "Explosives, Pyrotechnic Products, Matches – Includes fireworks and safety fuses.",
      "keywords": [],
      "types": [],
      "name": "explosives-fireworks"
    },
    {
      "chapter": "37",
      "description": "Photographic or Cinematographic Products – Covers films, plates, and processing chemicals.",
      "keywords": [],
      "types": [],
      "name": "photographic-films-plates"
    },
    {
      "chapter": "38",
      "description": "Miscellaneous Chemical Products – Includes insecticides, adhesives, and lab chemicals.",
      "keywords": [],
      "types": [],
      "name": "miscellaneous-chemical-products"
    },
    {
      "chapter": "39",
      "description": "Plastics & Articles Thereof – Includes plastic sheets, tubes, and containers.",
      "keywords": [],
      "types": [],
      "name": "plastics"
    },
    {
      "chapter": "40",
      "description": "Rubber & Articles Thereof – Covers natural and synthetic rubber, tires, and hoses.",
      "keywords": ["rubber", "synthetic rubber", "tyres", "tires", "hoses"],
      "types": [],
      "name": "rubber-tyres"
    },
    {
      "chapter": "41",
      "description": "Raw Hides & Leather – Includes animal hides, skins, and finished leather.",
      "keywords": [],
      "name": "raw-leather"
    },
    {
      "chapter": "42",
      "description": "Leather Goods, Saddlery, & Travel Items – Covers handbags, belts, and saddlery.",
      "keywords": [],
      "types": [],
      "name": "leather"
    },
    {
      "chapter": "43",
      "description": "Fur Skins & Artificial Fur – Includes fur coats and artificial fur products.",
      "keywords": [],
      "types": [],
      "name": "fur-skin-fur-coats"
    },
    {
      "chapter": "44",
      "description": "Wood & Wood Articles – Includes logs, plywood, and wooden furniture.",
      "keywords": [],
      "types": [],
      "name": "wood-plywood"
    },
    {
      "chapter": "45",
      "description": "Cork & Cork Articles – Covers cork sheets and cork stoppers.",
      "keywords": [],
      "types": [],
      "name": "cork-stoppers"
    },
    {
      "chapter": "46",
      "description": "Basketware & Wickerwork – Includes baskets and woven bamboo products.",
      "keywords": [],
      "types": [],
      "name": "basketware-bamboo"
    },
    {
      "chapter": "47",
      "description": "Pulp of Wood or Other Cellulose Fibers – Includes wood pulp for papermaking.",
      "keywords": [],
      "types": [],
      "name": "pulp"
    },
    {
      "chapter": "48",
      "description": "Paper & Paperboard Articles – Covers writing paper, cartons, and tissue paper.",
      "keywords": [],
      "types": [],
      "name": "paper-paperboard"
    },
    {
      "chapter": "49",
      "description": "Printed Books, Newspapers, & Other Printed Matter – Includes books, magazines, and maps.",
      "keywords": [],
      "types": [],
      "name": "printed-books"
    },
    {
      "chapter": "50",
      "description": "Silk",
      "keywords": [],
      "types": [],
      "name": "silk"
    },
    {
      "chapter": "51",
      "description": "Wool, Fine or Coarse Animal Hair",
      "keywords": [],
      "types": [],
      "name": "wool-animal-hair"
    },
    {
      "chapter": "52",
      "description": "Cotton",
      "keywords": [],
      "types": [],
      "name": "cotton"
    },
    {
      "chapter": "53",
      "description": "Other Vegetable Textile Fibres",
      "keywords": [],
      "types": [],
      "name": "vegetable-textile-fibres"
    },
    {
      "chapter": "54",
      "description": "Man-Made Filaments",
      "keywords": [],
      "types": [],
      "name": "man-made-filaments"
    },
    {
      "chapter": "55",
      "description": "Man-Made Staple Fibres",
      "keywords": [],
      "types": [],
      "name": "man-made-staple-fibres"
    },
    {
      "chapter": "56",
      "description": "Wadding, Felt & Nonwovens",
      "keywords": [],
      "types": [],
      "name": "wadding-special-yarns"
    },
    {
      "chapter": "57",
      "description": "Carpets & Other Textile Floor Coverings",
      "keywords": [],
      "types": [],
      "name": "carpets"
    },
    {
      "chapter": "58",
      "description": "Special Woven Fabrics",
      "keywords": [],
      "types": [],
      "name": "woven-fabrics"
    },
    {
      "chapter": "59",
      "description": "Impregnated, Coated, Covered Textile Fabrics",
      "keywords": [],
      "types": [],
      "name": "fabrics,"
    },
    {
      "chapter": "60",
      "description": "Knitted or Crocheted Fabrics",
      "keywords": ["Knitted"],
      "types": [],
      "name": "knitted-fabrics"
    },
    {
      "chapter": "61",
      "description": "Articles of Apparel & Clothing Accessories (Knitted)",
      "keywords": ["Knitted"],
      "types": [],
      "name": "Knitted-clotes-apparel"
    },
    {
      "chapter": "62",
      "description": "Articles of Apparel & Clothing Accessories (Not Knitted)",
      "keywords": ["apparel", "clothing"],
      "types": [],
      "name": "apparel-clothing"
    },
    {
      "chapter": "63",
      "description": "Other Made-Up Textile Articles",
      "keywords": ["textile"],
      "types": [],
      "name": "textile-other"
    },
    {
      "chapter": "64",
      "description": "Footwear – Covers shoes, boots, and sandals.",
      "keywords": [],
      "types": [],
      "name": "footwear"
    },
    {
      "chapter": "65",
      "description": "Headgear & Parts Thereof – Includes hats, caps, and helmets.",
      "keywords": [],
      "types": [],
      "name": "headgear-caps-hats"
    },
    {
      "chapter": "66",
      "description": "Umbrellas, Walking Sticks, & Similar Articles – Covers umbrellas and canes.",
      "keywords": [],
      "types": [],
      "name": "umbrellas-walking-sticks"
    },
    {
      "chapter": "67",
      "description": "Prepared Feathers, Artificial Flowers, & Wigs – Includes artificial flowers and hair accessories.",
      "keywords": [],
      "types": [],
      "name": "artificial-flowers"
    },
    {
      "chapter": "68",
      "description": "Stone, Plaster, Cement, & Asbestos Articles – Includes building materials.",
      "keywords": [],
      "types": [],
      "name": "stone-cement"
    },
    {
      "chapter": "69",
      "description": "Ceramic Products – Covers tiles, porcelain, and pottery.",
      "keywords": [],
      "types": [],
      "name": "ceramic-tiles"
    },
    {
      "chapter": "70",
      "description": "Glass & Glassware – Includes bottles, mirrors, and fiberglass.",
      "keywords": [],
      "types": [],
      "name": "glass-glassware"
    },
    {
      "chapter": "71",
      "description": "Natural Pearls, Precious Stones, & Metals – Covers gold, silver, and diamonds.",
      "keywords": [],
      "types": [],
      "name": "natural-stones"
    },
    {
      "chapter": "72",
      "description": "Iron & Steel",
      "keywords": [],
      "types": [],
      "name": "iron-steal"
    },
    {
      "chapter": "73",
      "description": "Articles of Iron or Steel",
      "keywords": [],
      "types": [],
      "name": "iron-steal-articles"
    },
    {
      "chapter": "74",
      "description": "Copper & Articles Thereof",
      "keywords": [],
      "types": [],
      "name": "copper"
    },
    {
      "chapter": "75",
      "description": "Nickel & Articles Thereof",
      "keywords": [],
      "types": [],
      "name": "nickel"
    },
    {
      "chapter": "76",
      "description": "Aluminum & Articles Thereof",
      "keywords": [],
      "types": [],
      "name": "aluminum"
    },
    {
      "chapter": "77",
      "description": "Lead & Articles Thereof",
      "keywords": [],
      "types": [],
      "name": "lead"
    },
    {
      "chapter": "78",
      "description": "Zinc & Articles Thereof",
      "keywords": [],
      "types": [],
      "name": "zinc"
    },
    {
      "chapter": "79",
      "description": "Tin & Articles Thereof",
      "keywords": [],
      "types": [],
      "name": "tin-articles"
    },
    {
      "chapter": "80",
      "description": "Other Base Metals & Articles",
      "keywords": [],
      "types": [],
      "name": "other-base-metal"
    },
    {
      "chapter": "81",
      "description": "Tools, Implements, Cutlery",
      "keywords": [],
      "types": [],
      "name": "tools-cutlery,"
    },
    {
      "chapter": "82",
      "description": "Miscellaneous Articles of Base Metal",
      "keywords": [],
      "types": [],
      "name": "miscellaneous-metal"
    },
    {
      "chapter": "83",
      "description": "Nuclear Reactors, Boilers, Machinery",
      "keywords": [],
      "types": [],
      "name": "nuclear"
    },
    {
      "chapter": "84",
      "description": "Machinery & Mechanical Appliances – Includes engines, turbines, and tools",
      "keywords": ["engines", "turbines", "tools"],
      "types": [],
      "name": "machinery"
    },
    {
      "chapter": "85",
      "description": "Electrical Machinery & Equipment – Covers electrical generators, cables, and batteries.",
      "keywords": ["electrical", "generators", "cables", "batteries"],
      "types": [],
      "name": "electrical"
    },
    {
      "chapter": "86",
      "description": "Vehicles Other Than Railway",
      "keywords": [],
      "types": [],
      "name": "vehicles"
    },
    {
      "chapter": "87",
      "description": "Aircraft, Spacecraft, & Parts",
      "keywords": [],
      "types": [],
      "name": "aircraft,"
    },
    {
      "chapter": "88",
      "description": "Ships, Boats & Floating Structures",
      "keywords": [],
      "types": [],
      "name": "ships,"
    },
    {
      "chapter": "89",
      "description": "Optical, Photographic Instruments",
      "keywords": [],
      "types": [],
      "name": "optical-photographic,"
    },
    {
      "chapter": "90",
      "description": "Optical, Photographic, & Medical Instruments – Includes microscopes, lenses, and medical devices.",
      "keywords": [],
      "types": [],
      "name": "optical-photo-medical"
    },
    {
      "chapter": "91",
      "description": "Clocks & Watches – Covers timepieces and clocks.",
      "keywords": [],
      "types": [],
      "name": "clocks-watches"
    },
    {
      "chapter": "92",
      "description": "Musical Instruments – Includes pianos, guitars, and violins.",
      "keywords": [],
      "types": [],
      "name": "musical-instruments"
    },
    {
      "chapter": "93",
      "description": "Arms & Ammunition – Covers weapons and explosives.",
      "keywords": [],
      "types": [],
      "name": "arms"
    },
    {
      "chapter": "94",
      "description": "Furniture, Bedding, & Lighting – Includes chairs, beds, and lamps.",
      "keywords": [],
      "types": [],
      "name": "furniture,"
    },
    {
      "chapter": "95",
      "description": "Toys, Games, & Sports Equipment – Covers video games, toys, and sporting goods.",
      "keywords": [],
      "types": [],
      "name": "toys"
    },
    {
      "chapter": "96",
      "description": "Miscellaneous Manufactured Articles – Includes pens, buttons, and combs.",
      "keywords": ["pens", "buttons", "combs"],
      "types": [],
      "name": "miscellaneous-manufactured-pen-buttons"
    },
    {
      "chapter": "97",
      "description": "Works of Art, Collectibles, & Antiques – Covers paintings, sculptures, and artifacts.",
      "keywords": [],
      "types": [],
      "name": "works-of-art"
    },
    {
      "chapter": "98",
      "description": "Special Classification – Covers non-specified goods.",
      "keywords": [],
      "productName": "special gifts",
      "types": [],
      "name": "special-non-specified"
    },
    {
      "chapter": "99",
      "description": "Special classification provisions : Temporary imports and exports,Goods imported for specific purposes \n",
      "keywords": [],
      "productName": "sample item",
      "types": [],
      "name": "special-classification"
    }
  ]